import DOMPurify from "dompurify";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const BASE_URL = API_URL.replace("/api", "");

/**
 * Get full image URL from relative path
 * - Absolute URLs (http...) → returned as-is
 * - Local frontend paths (/Images/...) → returned as-is (served from public/)
 * - Backend upload paths (/uploads/...) → prepended with backend BASE_URL
 */
export const getImageUrl = (path) => {
  if (!path) return "/placeholder.jpg";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/Images/")) return path;
  return `${BASE_URL}${path}`;
};

/**
 * Sanitize HTML content for rendering
 */
export const sanitizeHTML = (html) => {
  if (!html) return "";
  return DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
};

/**
 * Truncate text
 */
export const truncate = (text, len = 100) => {
  if (!text) return "";
  return text.length > len ? text.substring(0, len) + "..." : text;
};

/**
 * Strip HTML tags
 */
export const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
};

/**
 * Format date
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};
